<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: More Beautiful Than Death, by David Mack" class="imagefp" epub:type="cover" role="doc-cover" src="e9781982140632/images/9781982140632.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?29573353